
const { EventEmitter } = require('events');

const _ = require('lodash');


class Notification extends EventEmitter {
	constructor (options) {
		super();

		options = _.defaultsDeep(options || {}, {
			css: {},
			dismissibleByUser: true,

			template: null,
			component: null,
			autoExpire: {
				clickCount: 3,
				enable: true,
			},
		});

		Object.assign(this, options);
	}

	isEmpty () {
		return !this.template
			&& !this.component;
	}
}

module.exports = Notification;

